<template>
  <div>
    <div
      v-if="activeStatus === '0'"
      class="check_box"
      :style="{ background: `url(${dakaInfo.activityBackgroundPicture})` }"
    >
      <div class="check_time" v-if="endTime">
        <div>活动倒计时：</div>
        <CommonTimer :endTime="endTime" />
        <!-- <div class="check_item_hour_num"></div> -->
        <!-- 天 -->
      </div>
      <div class="check_main_image">
        <img :src="dakaInfo.activityPicture" alt />
      </div>
      <div class="check_main_content">
        <!-- 未开始状态 -->
        <!-- 未参与-活动说明 -->
        <div v-if="dakaInfo.dakaNumber === 0 || !userInfo.id" class="detail piece_pub">
          <div class="content_top">
            <img src="https://iqh-zt-pord-cdn.iqihang.com/ark-student-wap/check/detail.png" alt />
          </div>

          <div class="pub_content">
            <div class="dc_check">
              <img src="https://iqh-zt-pord-cdn.iqihang.com/ark-student-wap/check/check.png" alt />
              <span>{{ dakaInfo.activityName }}</span>
            </div>
            <div class="join_num">
              · 参与人数：
              <span>{{ dakaInfo.joinShowNumber }}</span>人已经参加
            </div>
            <div
              class="join_num active_time"
            >· 活动时间：{{ dakaInfo.startTime }} - {{ dakaInfo.endTime }}</div>
          </div>
        </div>

        <!-- 未参与-完成奖品 -->
        <div v-if="dakaInfo.dakaNumber === 0 || !userInfo.id" class="prize piece_pub">
          <div class="content_top">
            <img src="https://iqh-zt-pord-cdn.iqihang.com/ark-student-wap/check/prize.png" alt />
          </div>

          <div class="pub_content">
            <img class="prize_img" :src="dakaInfo.dakaActivityPrizeDataList.prizePicture" />
            <div class="prize_name">{{ dakaInfo.dakaActivityPrizeDataList.prizeName }}</div>
          </div>
        </div>

        <!-- 进行中状态 -->
        <!-- 进行中-我的进度 已完成也用此项，区别在于进度条下方文字展示-->
        <div v-if="dakaInfo.dakaNumber > 0 && userInfo.id" class="scheduleing piece_pub">
          <div class="content_top">
            <img src="https://iqh-zt-pord-cdn.iqihang.com/ark-student-wap/check/schedule.png" alt />
          </div>

          <div class="pub_content">
            <div class="sc_progress_bar">
              <div class="sc_left">
                <div class="sc_day">
                  <span>{{ dakaInfo.dakaNumber }}</span>
                  /{{ dakaInfo.signNumber }}
                </div>
                <div class="sc_bar">
                  <div
                    class="sc_bar_line"
                    :style="{ width: `${dakaInfo.dakaNumber / dakaInfo.signNumber * 100}%` }"
                  ></div>
                </div>
              </div>
              <img
                src="https://iqh-zt-pord-cdn.iqihang.com/ark-student-wap/check/prize_pkg.png"
                alt
              />
            </div>
            <div v-if="dakaInfo.dakaNumber < dakaInfo.signNumber" class="sc_text">还没有完成，继续加油</div>
            <div v-if="dakaInfo.dakaNumber === dakaInfo.signNumber" class="sc_text">已达成任务，快去领取奖品吧</div>
          </div>
        </div>

        <!-- 进行中-完成奖品 已完成也用此项，区别在于按钮处展示 差*天 还是 领取-->
        <div v-if="dakaInfo.dakaNumber > 0 && userInfo.id" class="prizeing piece_pub">
          <div class="content_top">
            <img src="https://iqh-zt-pord-cdn.iqihang.com/ark-student-wap/check/prize.png" alt />
          </div>

          <div class="pub_content">
            <img class="pcg_left_img" :src="dakaInfo.dakaActivityPrizeDataList.prizePicture" />
            <div class="pcg_right">
              <div class="pcg_title">{{ dakaInfo.dakaActivityPrizeDataList.prizeName }}</div>
              <div class="pcg_have">
                剩余
                <span>{{ dakaInfo.dakaActivityPrizeDataList.prizeStock }}</span>份
              </div>
              <div class="pcg_have">
                <div class="pcg_you">
                  打卡满
                  <span>{{ dakaInfo.signNumber }}</span> 天可领
                </div>
                <div
                  class="pcg_cha"
                  v-if="dakaInfo.dakaNumber < dakaInfo.signNumber && dakaInfo.dakaActivityPrizeDataList.prizeStock > 0"
                >
                  差
                  <span>
                    {{ dakaInfo.signNumber -
                    dakaInfo.dakaNumber }}
                  </span>天
                </div>
                <div
                  class="pcg_cha pcg_wc"
                  v-if="dakaInfo.dakaNumber === dakaInfo.signNumber && !(dakaInfo.dakaActivityPrizeDataList.isReceive || addressId) && dakaInfo.dakaActivityPrizeDataList.prizeStock > 0"
                  @click="onOpenReceive"
                >
                  {{
                  '领取奖品' }}
                </div>
                <div
                  class="pcg_cha pcg_lq"
                  @click="openSuccModel"
                  v-if="dakaInfo.dakaActivityPrizeDataList.isReceive || addressId"
                >已领奖</div>
              </div>
            </div>
          </div>
        </div>

        <!-- 活动规则item，三种状态通用 -->
        <div class="rule piece_pub">
          <div class="content_top">
            <img src="https://iqh-zt-pord-cdn.iqihang.com/ark-student-wap/check/rule.png" alt />
          </div>

          <div class="pub_content">
            <div class="rc_item" v-for="item in dakaInfo.activityRule" :key="item">{{ item }}</div>
          </div>
        </div>
      </div>
      <CanvasImg :activityInfo="dakaInfo" ref="canvasImg" />
      <!-- 底部按钮 -->
      <div class="check_main_bottom">
        <div
          v-if="dakaInfo.dakaNumber > 0 && dakaInfo.dakaNumber < dakaInfo.signNumber"
          @click="goDaka"
          class="bottom_btn"
        >
          {{
          dakaInfo.todayDone ? '今日已打卡' : '去打卡' }}
        </div>
        <div v-if="dakaInfo.dakaNumber === 0" @click="goDaka" class="bottom_btn">马上参与</div>
        <div v-if="dakaInfo.dakaNumber < dakaInfo.signNumber" class="bottom_btm_empy"></div>
        <div v-if="dakaInfo.dakaNumber < dakaInfo.signNumber" @click="share" class="bottom_btn">分享活动</div>
        <div
          v-if="dakaInfo.dakaNumber === dakaInfo.signNumber"
          @click="share"
          class="bottom_btn_big"
        >分享活动</div>
      </div>

      <!-- 领取奖品弹窗 -->
      <van-popup
        v-model="show"
        closeable
        :close-on-click-overlay="false"
        :style="{ top: '242px', transform: 'translate3d(-50%, 0, 0)' }"
      >
        <div class="vm_model">
          <div class="vm_tip">
            <div
              class="tip_title"
              v-if="!addressId && dakaInfo.dakaActivityPrizeDataList.isAddress"
            >温馨提示</div>
            <div
              class="tip_title"
              v-if="addressId || !dakaInfo.dakaActivityPrizeDataList.isAddress"
            >领取成功</div>
            <div class="tip_text">
              <span
                v-if="dakaInfo.dakaActivityPrizeDataList.isAddress"
              >{{ dakaInfo.dakaActivityPrizeDataList.prizeType === 1 ? '您领取的奖品为实物奖品' : '您领取的奖品需要寄送' }}</span>
              <span v-if="dakaInfo.dakaActivityPrizeDataList.isAddress && !addressId">请填写地址方便寄送哦</span>
              <span v-if="dakaInfo.dakaActivityPrizeDataList.isAddress && addressId">我们将在活动结束后15日内发货</span>

              <span v-if="!dakaInfo.dakaActivityPrizeDataList.isAddress">
                {{
                `您领取的奖品为${dakaInfo.dakaActivityPrizeDataList.prizeType === 2 ? '课程' : '优惠卷'}` }}
              </span>
              <span v-if="!dakaInfo.dakaActivityPrizeDataList.isAddress">请关注个人账户哦~</span>
            </div>
            <div v-if="addressId" class="tip_address">{{ address }}</div>
            <div
              v-if="dakaInfo.dakaActivityPrizeDataList.isAddress && !addressId"
              class="tip_address"
            >*未填写地址视为放弃奖品</div>
            <div class="tip_btn" @click="knowCloseReceive">
              {{ (dakaInfo.dakaActivityPrizeDataList.isAddress && !addressId) ?
              '去填写' : '知道了' }}
            </div>
          </div>
        </div>
      </van-popup>

      <!-- 领取奖品-选择规格弹窗 -->
      <van-popup
        v-model="prizeShow"
        closeable
        :close-on-click-overlay="false"
        :style="{ top: '142px', transform: 'translate3d(-50%, 0, 0)' }"
      >
        <div class="vm_model">
          <div class="vm_tip">
            <div class="tip_title">温馨提示</div>
            <div class="tip_text">
              <span>该实物需要选择规格，请选择规格后</span>
              <span>再进行地址的填写</span>
            </div>
            <div class="spec_box">
              <div v-for="(item, index) in specJson" :key="index">
                <span>{{ item.name }}</span>
                <div class="spec_list">
                  <div
                    v-for="(v, key) in item.checkValues"
                    :key="key"
                    :style="specStyle(v, index) ? specStyle(v, index) : (checkSpec.find(item => item.check === v) ? { color: '#FFF', background: '#FF7F41' } : {})"
                    @click="changeSpec(v, index)"
                  >{{ v }}</div>
                  <div
                    style="visibility: hidden;"
                    v-for="item in (3 - item.checkValues.length % 3)"
                    :key="item"
                  ></div>
                </div>
              </div>
            </div>
            <div class="tip_btn" @click="knowCloseReceive">去填写</div>
          </div>
        </div>
      </van-popup>

      <!-- 领取成功弹窗 -->
      <van-popup
        v-model="succShow"
        closeable
        :close-on-click-overlay="false"
        :style="{ top: '242px', transform: 'translate3d(-50%, 0, 0)' }"
      >
        <div class="vm_model">
          <div class="vm_tip">
            <div class="tip_title">领取成功</div>
            <div class="tip_text">
              <span v-if="dakaInfo.dakaActivityPrizeDataList.prizeType === 1">您领取的奖品为实物奖品</span>
              <span
                v-if="dakaInfo.dakaActivityPrizeDataList.prizeType === 2"
              >{{ dakaInfo.dakaActivityPrizeDataList.isAddress ? '您领取的奖品需要寄送' : '您领取的奖品为课程' }}</span>
              <span v-if="dakaInfo.dakaActivityPrizeDataList.prizeType === 3">您领取的奖品为优惠卷</span>
              <span>{{ dakaInfo.dakaActivityPrizeDataList.isAddress ? '我们将在活动结束后15日内发货' : '请关注个人账户哦' }}</span>
            </div>
            <div class="tip_btn" @click="closeSuccModel">知道了</div>
          </div>
        </div>
      </van-popup>
    </div>
    <div class="no_open" v-if="activeStatus === '1'">
      <img
        class="no_open_img"
        src="https://iqh-zt-pord-cdn.iqihang.com/ark-student-wap/check/noopen.png"
        alt
      />
      <div class="no_open_text">活动暂未开始，看看其他活动吧~</div>
    </div>
    <div class="no_open" v-if="activeStatus === '2'">
      <img
        class="no_open_img"
        src="https://iqh-zt-pord-cdn.iqihang.com/ark-student-wap/check/close.png"
        alt
      />
      <div class="no_open_text">活动已结束，看看其他活动吧~</div>
    </div>
    <div class="no_open" v-if="activeStatus === '3'">
      <img
        class="no_open_img"
        src="https://iqh-zt-pord-cdn.iqihang.com/ark-student-wap/check/stop.png"
        alt
      />
      <div class="no_open_text">
        活动已关闭或奖品已全部领完，
        <br />看看其他活动吧~
      </div>
    </div>
  </div>
</template>

<script>
import CommonTimer from '@/components/commonComponents/CommonTimer.vue';
import moment from 'moment';
// eslint-disable-next-line import/no-cycle
import { getActiveDetail, givePrize } from '@/api/check';
import { reqSchemeUrl } from '@/api/openMini';
import { reqAddressList } from '@/api/personal/addressController';
import { whatEev } from '@/utils/tools';
import wx from 'weixin-js-sdk';
import { mapState } from 'vuex';
import { reqCheckProduct } from '@/api/pay';
import CanvasImg from './component/canvasImg.vue';

const urlObj = {
  0: '/pages/chooseLogin/chooseLogin',
  1: '/longSentences/list/list',
  2: '/zhangyuPractice/home/index',
};

export default {
  components: {
    CommonTimer,
    CanvasImg,
  },
  // 根据userInfo.id 判断是否登录
  computed: {
    ...mapState(['userInfo']),
    specStyle() {
      return function(v, index) {
        const aaa = this.specHas(v, index);
        return aaa ? { background: 'rgb(245, 245, 245)', cursor: 'no-drop' } : false;
      };

      // return this.checkSpec.find(item => item.check === v) ? { color: '#FFF', background: '#FF7F41' } : {}
    },
  },
  watch: {
    prizeShow(newVal) {
      if (!newVal) {
        const specLs = JSON.parse(JSON.stringify(this.checkSpec));
        this.checkSpec = specLs.map(item => ({ type: item.type }));
      }
    },
  },
  data() {
    return {
      specJson: [], // 实物规格
      checkSpec: [], // 选择的实物规格
      endTime: '',
      show: false,
      prizeShow: false,
      succShow: false,
      activeStatus: '-1', // 0-进行中 1-未开始 2-已结束 3-已关闭
      dakaInfo: {
        activityRule: [],
        dakaActivityPrizeDataList: {},
      },
      addressId: '',
      address: '',
    };
  },

  methods: {
    onOpenReceive() {
      if (this.isPreview === 1) {
        return;
      }
      if (this.dakaInfo.dakaActivityPrizeDataList.isReceive || this.addressId) {
        return;
      }

      // 如果有规格 则弹出规格弹窗
      if (this.dakaInfo.dakaActivityPrizeDataList.specJson !== '[]') {
        this.prizeShow = true;
        return;
      }
      console.log(
        this.dakaInfo.dakaActivityPrizeDataList.prizeType,
        this.dakaInfo.dakaActivityPrizeDataList.isAddress,
      );
      if (
        this.dakaInfo.dakaActivityPrizeDataList.prizeType === 1 ||
        (this.dakaInfo.dakaActivityPrizeDataList.prizeType === 2 &&
          this.dakaInfo.dakaActivityPrizeDataList.isAddress)
      ) {
        this.show = true;
      } else {
        const lqProzeInfo = {
          activityId: this.dakaInfo.activityId,
          activityPrizeId: this.dakaInfo.dakaActivityPrizeDataList?.activityPrizeId || '',
          terminalMark: this.$global.terminalMark,
          ip: sessionStorage.getItem('cityIp') || '',
        };
        givePrize(lqProzeInfo).then(pRes => {
          console.log(pRes);
          if (pRes.code === 0) {
            this.getInfo();
            this.show = true;
          } else {
            this.$toast(pRes.msg || '领取失败');
          }
        });
      }
      console.log('999');
    },
    knowCloseReceive() {
      if (this.isPreview === 1) {
        return;
      }
      if (this.dakaInfo.dakaActivityPrizeDataList.isAddress && !this.addressId) {
        // 去填写
        const isLq = this.checkSpec.every(spec => !!spec.check);
        if (!isLq && this.specJson && this.specJson.length > 0) {
          // this.$toast('请选择要领取的奖品规格')
          this.$toast({
            message: '请选择要领取的奖品规格',
            className: 'toastIndex',
          });
          return;
        }
        sessionStorage.setItem('checkSpec', JSON.stringify(this.checkSpec));
        // 去填写地址
        this.$router.push({
          path: '/personalCenter/address',
          query: {
            needBack: true,
            isActive: true,
          },
        });
      } else {
        this.show = false;
      }
    },
    openSuccModel() {
      this.succShow = true;
    },
    closeSuccModel() {
      this.succShow = false;
    },
    getInfo() {
      const { activityId: id, isPreview } = this.$route.query;
      getActiveDetail({ activityId: id, isPreview }).then(res => {
        const { data = {}, code } = res;
        if (code === 9001) {
          this.activeStatus = '1';
          return;
        }
        if (code === 9002) {
          this.activeStatus = '2';
          return;
        }
        if (code === 9408) {
          this.activeStatus = '3';
          return;
        }
        this.activeStatus = '0';
        const {
          activityRule,
          dakaActivityPrizeDataList,
          startTime,
          activityPicture,
          activityName,
          endTime,
          dakaNumber: dakaNum,
          joinShowNumber = 0,
        } = data;

        data.dakaActivityPrizeDataList = dakaActivityPrizeDataList[0] || {};
        data.activityRule = activityRule.split('\n') || [];
        data.dakaNumber = Number(dakaNum);
        data.joinShowNumber = Number(joinShowNumber);
        data.startTime = startTime.slice(0, 10).replace(/-/g, '.');
        data.endTime = endTime.slice(0, 10).replace(/-/g, '.');

        const { specJson = '', prizeSkuVOList = [] } = dakaActivityPrizeDataList[0] || {};

        if (this.$root.miniprogram) {
          document.title = data.activityName;
        }

        // 如果奖品类型是课程，则需要单独查是否需要地址
        if (data.dakaActivityPrizeDataList.prizeType === 2) {
          const { productId, productSkuId } = data.dakaActivityPrizeDataList;
          const subData = {
            products: [
              {
                productId,
                productSkuId,
                quantity: 1,
                type: 1,
              },
            ],
            userId: this.userInfo.id,
          };
          reqCheckProduct(subData).then(cRes => {
            const { code: adCode, data: adData } = cRes;
            if (adCode === 0 && adData.needAddress) {
              // 需要地址
              data.dakaActivityPrizeDataList.isAddress = true;
            } else {
              // 不需要地址
              data.dakaActivityPrizeDataList.isAddress = false;
            }
          });
        }

        // 处理规格sku信息 规格：余量（限量 - 销量）
        let specMap = {};
        let specDanMap = {};

        // 临时假数据
        // prizeSkuVOList[0].canExchange = false
        // prizeSkuVOList[1].canExchange = false
        // prizeSkuVOList[2].canExchange = false
        // prizeSkuVOList[3].canExchange = false

        prizeSkuVOList?.forEach(vo => {
          const { skuName, canExchange } = vo;
          specMap[skuName] = Number(canExchange);

          const danSpecList = skuName?.split(',') || [];
          if (canExchange) {
            danSpecList.forEach(d => {
              specDanMap[d] = true;
            });
          }
        });
        console.log('guige init', specMap, specDanMap);
        this.specMap = specMap;
        this.specDanMap = specDanMap;

        this.dakaInfo = data;
        this.endTime = moment(endTime).format('X');
        this.specJson = JSON.parse(specJson || '[]');
        this.checkSpec = JSON.parse(specJson || '[]').map(item => {
          // const result = {
          //   type: item.name
          // }
          // if(item.checkValues.find((itm) => specDanMap[itm])){
          //   result.check = item.checkValues.find((itm) => !!specDanMap[itm])
          // }
          return {
            type: item.name,
          };
        });

        // 假数据区域
        // this.userInfo.id = '99';
        // data.dakaNumber = 1
        // data.signNumber = 1
        // this.dakaNumber = 1
        // =====

        const { dakaNumber, signNumber, isReceive, activityId } = data;
        // 未领取过且打卡天数满足
        if (!isReceive && dakaNumber === signNumber) {
          const addressId = sessionStorage.getItem('addressId');
          // 有addressId说明从选择地址页跳回的，可以走领取接口
          if (addressId) {
            // 从缓存中取到刚才选择的规格
            const cacheCheckSpec = sessionStorage.getItem('checkSpec') || JSON.stringify([]);
            this.checkSpec = JSON.parse(cacheCheckSpec);
            sessionStorage.removeItem('checkSpec');

            reqAddressList({ pageNum: 1, pageSize: 50 }).then(addRes => {
              const addressList = addRes?.data?.data || [];
              console.log(addRes);
              const addressInfo = addressList.find(item => item.id === Number(addressId)) || {};
              const { province, city, area, address } = addressInfo;
              const lqProzeInfo = {
                activityId,
                activityPrizeId: dakaActivityPrizeDataList[0]?.activityPrizeId || '',
                userAddressId: addressId,
                terminalMark: this.$global.terminalMark,
                ip: sessionStorage.getItem('cityIp') || '',
              };
              if (this.checkSpec.length > 0) {
                lqProzeInfo.specJson = JSON.stringify(this.checkSpec);
              }
              console.log('lqProzeInfo', lqProzeInfo);
              givePrize(lqProzeInfo)
                .then(pRes => {
                  console.log(pRes);
                  if (pRes.code === 0) {
                    this.address = `${province}${city}${area}${address}`;
                    this.addressId = addressId;
                    this.show = true;
                    sessionStorage.setItem('addressId', '');
                    this.getInfo();
                  } else {
                    sessionStorage.setItem('addressId', '');
                    this.$toast(pRes.msg || '领取失败');
                  }
                })
                .finally(() => {
                  const specLs = JSON.parse(JSON.stringify(this.checkSpec));
                  this.checkSpec = specLs.map(item => ({ type: item.type }));
                });
            });
          }
        }
        this.wxInit(activityPicture, activityName, activityId);
        console.log(JSON.stringify(data));
      });
    },
    share() {
      if (this.isPreview === 1) {
        return;
      }
      this.$refs.canvasImg.createImg();
    },
    wxInit(activityPicture, activityName, activityId) {
      wx.ready(() => {
        // 需在用户可能点击分享按钮前就先调用
        wx.miniProgram.postMessage({
          data: {
            title: activityName,
            imageUrl: activityPicture,
            path: `${window.location.origin}${window.location.pathname}?activityId=${activityId}&isPreview=0`,
          },
        });
      });
    },
    goDaka() {
      if (this.isPreview === 1) {
        return;
      }
      if (whatEev() === 'miniprogram') {
        wx.miniProgram.redirectTo({
          url: urlObj[this.dakaInfo.dakaType],
        });
      } else if (this.$root.$data.isApp) {
        this.$sendToApp('goWechatProject', {
          userName: 'gh_5fb96ed24012',
          path: urlObj[this.dakaInfo.dakaType],
        });
      } else {
        this.getSchemeUrl();
      }
    },
    async getSchemeUrl() {
      const data = {
        appid: 'wxdb89cfa2bb60f779',
        path: urlObj[this.dakaInfo.dakaType],
        envVersion: !window.location.host.includes('mobile-test') ? 'release' : 'trial',
      };
      const res = await reqSchemeUrl(data);
      if (res?.code === 0) {
        this.chatUrl = res.data;
        window.location.href = res.data;
      }
    },

    // 奖品规格判断函数
    specHas(currSpec, index) {
      // console.log('currSpec', this.specDanMap[currSpec])

      if (!this.specDanMap[currSpec]) {
        return true;
      }

      // console.log('kjinbuqbfor???', this.specMap)

      const specMapList = Object.keys(this.specMap);

      let seach = false;

      for (let i = 0; i < specMapList.length; i++) {
        const spec = specMapList[i];

        let is = false;

        // console.log('for - i', i, spec)

        for (let j = 0; j < this.checkSpec.length; j++) {
          const { check } = this.checkSpec[j];
          if (check && index !== j) {
            if (spec.indexOf(check) === -1) {
              break;
            }
            console.log(
              'tiapshi:',
              `i:${i}, j:${j}, spec:${spec}, check:${check}, currSpec:${currSpec}`,
            );
          }
          // console.log('tiaoshi ', currSpec, i, j, spec, check, spec.indexOf(check))
          if (j === this.checkSpec.length - 1 && spec.indexOf(currSpec) !== -1) {
            is = true;
            seach = true;
          }
        }
        console.log(is, i, this.specMap[specMapList[i]], 'is');
        if (is && this.specMap[specMapList[i]] > 0) {
          return false;
        }
      }
      if (seach) {
        return true;
      }
      return false;
    },

    // // 返回样式方法
    // specStyle(v) {

    //   const aaa = this.specHas(v)

    //   console.log('aaa', aaa)
    //   if (aaa) {
    //     return { background: 'rgb(0, 245, 245)', cursor: 'no-drop' }
    //   }

    //   return this.checkSpec.find(item => item.check === v) ? { color: '#FFF', background: '#FF7F41' } : {}
    // },

    changeSpec(value, index) {
      const aaa = this.specHas(value, index);
      console.log('aaabian', aaa);
      if (aaa) {
        this.$toast({
          message: '奖品送光啦，请选择其他奖品吧',
          className: 'toastIndex',
        });
        return;
      }
      const ls = this.checkSpec;
      ls[index].check = value;
      console.log('ls', ls);
      this.checkSpec = ls;
      setTimeout(() => {
        this.specJson = [...this.specJson];
        console.log(this.checkSpec);
      }, 0);
    },
  },

  mounted() {
    console.log('mountedzhixingl', sessionStorage.getItem('addressId'));
    const { isPreview = 0 } = this.$route.query;
    this.isPreview = Number(isPreview);
    this.getInfo();
  },
};
</script>

<style lang="scss">
.toastIndex {
  z-index: 10000001 !important;
}
</style>

<style scoped lang="scss">
.check_box {
  position: relative;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  justify-items: baseline;
  width: 100%;
  padding-bottom: 174px;
  font-family: PingFangSC, PingFang SC, sans-serif;
  // background: #D1F8FF;
  // background: rgb(194, 128, 255);

  .check_time {
    position: fixed;
    top: 0;
    display: flex;
    align-items: center;
    justify-content: center;
    width: 750px;
    height: 51px;
    color: #fff;
    font-size: 25px;
    background: rgba(0, 0, 0, 0.3);
  }

  .check_main_image {
    width: 750px;
    height: 500px;

    img {
      width: 100%;
      height: 100%;
    }

    // background: rgb(214, 248, 254);
  }

  .check_main_content {
    flex: 1;
    width: 750px;
    height: 1399px;
    overflow: hidden;

    .piece_pub {
      box-sizing: border-box;
      // height: 322px;
      width: 678px;
      margin: 36px auto 0;
      padding: 18px;
      background: rgba(255, 255, 255, 0.4);
      // aspect-ratio: 11/5;
      border: 2px solid #fff;
      border-radius: 29px;

      .content_top {
        width: 641px;
        height: 109px;

        img {
          width: 100%;
          height: 100%;
        }
      }

      .pub_content {
        width: 641px;
        overflow: hidden;
        background-color: #fff;
        border-bottom-right-radius: 22px;
        border-bottom-left-radius: 22px;
      }
    }

    .detail {
      .pub_content {
        padding: 9px 29px 29px;

        .dc_check {
          display: flex;
          // align-items: center;
          // height: 36px;

          img {
            width: 70px;
            height: 36px;
          }

          span {
            display: -webkit-box;
            margin-left: 16px;
            overflow: hidden;
            color: #333;
            font-weight: 500;
            font-size: 25px;
            line-height: 36px;
            text-overflow: ellipsis;
            -webkit-line-clamp: 2;
            -webkit-box-orient: vertical;
          }
        }

        .join_num {
          display: flex;
          height: 36px;
          margin-top: 22px;
          color: #666;
          font-weight: 400;
          font-size: 25px;
          line-height: 36px;

          span {
            color: #ff7f41;
          }
        }

        .active_time {
          height: 36px;
          margin-top: 11px;
          color: #666;
          font-weight: 400;
          font-size: 25px;
          line-height: 36px;
        }
      }
    }

    .prize {
      .pub_content {
        display: flex;
        flex-direction: column;
        padding-bottom: 18px;
        // justify-content: center;
      }

      .prize_img {
        display: block;
        width: 163px;
        height: 163px;
        // margin-top: 8px;
        margin: 7px auto;
        overflow: hidden;
        border: 2px solid #ffeaf1;
        border-radius: 25px;
      }

      .prize_name {
        width: 100%;
        height: 33px;
        margin-top: 11px;
        color: #333;
        font-weight: 500;
        font-size: 25px;
        line-height: 33px;
        text-align: center;
      }
    }

    .rule {
      .pub_content {
        padding: 9px 29px 14px;
        padding-top: 8px;
        padding-bottom: 16px;
      }

      .rc_item {
        margin-bottom: 22px;
        color: #333;
        font-weight: 400;
        // height: 40px;
        font-size: 28px;
        line-height: 40px;
      }
    }

    .scheduleing {
      .pub_content {
        width: 641px;
        padding-bottom: 36px;
      }

      .sc_progress_bar {
        display: flex;

        .sc_left {
          width: 507px;
          margin-top: 9px;
          margin-left: 36px;

          .sc_day {
            float: right;
            height: 25px;
            margin-bottom: 9px;
            padding-right: 8.5px;
            // width: 51px;
            padding-left: 8.5px;
            color: #333;
            font-weight: 400;
            font-size: 16px;
            font-family: PingFangSC, PingFang SC, sans-serif;
            line-height: 25px;
            background: #ffeee6;
            border-radius: 5px;

            span {
              color: #ff7f41;
            }
          }

          .sc_bar {
            float: left;
            // width: 507px;
            width: 100%;
            height: 18px;
            background: #efefef;
            border-radius: 12px;
          }

          .sc_bar_line {
            height: 18px;
            background: #ff7f41;
            // width: 50%;
            border-radius: 12px;
          }
        }

        img {
          display: block;
          width: 47px;
          height: 47px;
          margin-top: 24px;
          margin-left: 18px;
        }
      }

      .sc_text {
        width: 100%;
        height: 40px;
        margin-top: 34px;
        color: #333;
        font-weight: 400;
        font-size: 25px;
        line-height: 40px;
        text-align: center;
      }
    }

    .prizeing {
      .pub_content {
        // padding-left: 30px;
        padding-right: 0;
        padding-bottom: 49px;
      }

      .pcg_left_img {
        float: left;
        width: 163px;
        height: 163px;
        margin-top: 29px;
        margin-left: 36px;
        overflow: hidden;
        border: 2px solid #ffeaf1;
        border-radius: 25px;
      }

      .pcg_right {
        float: left;
        margin-top: 29px;
        margin-left: 29px;
        font-size: 25px;

        .pcg_title {
          height: 36px;
          color: #333;
          font-weight: 500;
          line-height: 36px;
        }

        .pcg_have {
          height: 36px;
          margin-top: 22px;
          font-weight: 400;
          line-height: 36px;

          span {
            color: #ff7f41;
            font-weight: 500;
          }

          .pcg_you {
            float: left;
          }

          .pcg_cha {
            float: left;
            width: 140px;
            height: 47px;
            margin-top: -6.5px;
            margin-left: 42px;
            font-weight: 400;
            line-height: 47px;
            text-align: center;
            background: #f5f5f5;
            border-radius: 26px;

            span {
              color: #ff7f41;
            }
          }

          .pcg_wc {
            color: #fff;
            background: #ff7f41;
          }

          .pcg_lq {
            color: #ff7f41;
            background: #fff;
            border: 2px solid #ff7f41;
            border-radius: 24px;
          }
        }
      }
    }
  }

  .check_main_bottom {
    // display: none;
    position: fixed;
    bottom: 0;
    display: flex;
    justify-content: space-between;
    box-sizing: border-box;
    // height: 174px;
    width: 750px;
    padding: 18px 40px 42px;
    background: #fff;
    border-radius: 36px 36px 0 0;
    box-shadow: 0 -2px 7px 0 rgba(0, 0, 0, 0.1);
  }

  .bottom_btn {
    // flex: 1;
    width: 326px;
    height: 91px;
    color: #fff;
    font-weight: 500;
    font-size: 32px;
    font-family: PingFangSC, PingFang SC, sans-serif;
    line-height: 91px;
    text-align: center;
    background: url('https://iqh-zt-pord-cdn.iqihang.com/ark-student-wap/check/active_btn.png')
      no-repeat;
    background-position: center center;
    background-size: 100%;
  }

  .bottom_btn_big {
    width: 670px;
    height: 91px;
    color: #fff;
    font-weight: 500;
    font-size: 32px;
    line-height: 91px;
    text-align: center;
    background: url('https://iqh-zt-pord-cdn.iqihang.com/ark-student-wap/check/daka_ok.png')
      no-repeat;
    background-position: center center;
    background-size: 100%;
  }

  ::v-deep .van-popup {
    width: 84.54%;
    border-radius: 20px;

    .vm_model {
      position: relative;
      overflow: hidden;

      .vm_tip {
        width: 100%;
        overflow: hidden;
        font-family: PingFangSC, PingFang SC, sans-serif;
        background: #fff;
        border-radius: 20px;

        .tip_title {
          height: 25px;
          margin-top: 28px;
          color: #333;
          font-weight: 500;
          font-size: 18px;
          line-height: 25px;
          text-align: center;
        }

        .tip_text {
          height: 40px;
          margin-top: 20px;
          font-size: 14px;
          line-height: 20px;

          span {
            display: block;
            width: 100%;
            color: #333;
            font-weight: 400;
            text-align: center;
          }
        }

        .tip_address {
          margin-top: 12px;
          padding-right: 40px;
          // height: 20px;
          // max-width: 66%;
          padding-left: 40px;
          color: #ff1a3f;
          font-weight: 400;
          font-size: 14px;
          line-height: 20px;
          text-align: center;
        }

        .tip_btn {
          // width: 231px;
          width: 66%;
          height: 44px;
          margin: 24px auto;
          color: #fff;
          font-weight: 500;
          font-size: 14px;
          line-height: 44px;
          text-align: center;
          background-color: #ff7f41;
          border-radius: 22px;
        }

        .spec_box {
          padding: 0 27px 0;

          span {
            height: 25px;
            color: #333;
            font-weight: 500;
            font-size: 15px;
            line-height: 19px;
          }

          .spec_list {
            display: flex;
            // gap: 9.5px;
            flex-wrap: wrap;
            justify-content: space-between;

            div {
              width: 30%;
              height: 38px;
              margin-top: 10px;
              color: #999;
              font-weight: 400;
              font-size: 12px;
              line-height: 34px;
              text-align: center;
              border: 1px solid #e8e8e8;
            }
          }
        }
      }
    }
  }
}

.no_open {
  width: 750px;
  height: 100vh;
  overflow: hidden;
  background: #f7f8fc;

  .no_open_img {
    display: block;
    width: 308px;
    height: 219px;
    margin: 428px auto 0;
  }

  .no_open_text {
    width: 750px;
    height: 40px;
    margin-top: 13px;
    color: #999;
    font-weight: 400;
    font-size: 25px;
    line-height: 40px;
    text-align: center;
  }
}
</style>
